export const SUPPORT_MAIL = process.env.REACT_APP_SUPPORT_EMAIL || 'info@waterharmonizerapp.com';
export const { REACT_APP_WATERHARMONIZER_API_KEY } = process.env;
